import { IAppointment, IServiceAppointment } from "@signal/asp-data-commons";

export function updateTimeSlot(appointment: IAppointment, time: string){
    const appointmentData = {} as IAppointment;
    appointmentData.timeSlotId = time;
    appointmentData.appointmentType = appointment.appointmentType;
    appointmentData.advisor = appointment.advisor;
    appointmentData.advisorId = appointment.advisorId;
    appointmentData.appointmentBookingSource = appointment.appointmentBookingSource;
    appointmentData.appointmentComments = appointment.appointmentComments;
    appointmentData.appointmentEndDate = appointment.appointmentEndDate;
    appointmentData.appointmentId = appointment.appointmentId;
    appointmentData.appointmentStartDate = appointment.appointmentStartDate;
    appointmentData.appointmentStatus = appointment.appointmentStatus;
    appointmentData.emailAddress = appointment.emailAddress;
    appointmentData.languageId = appointment.languageId;
    appointmentData.remoteDropTimeSlotId= appointment.remoteDropTimeSlotId;
    appointmentData.remoteEstimatedCompletionTime = appointment.remoteEstimatedCompletionTime;
    appointmentData.transportation = appointment.transportation;
    appointmentData.transportationTypeCode = appointment.transportationTypeCode;
    appointmentData.vehicle = appointment.vehicle;
    appointmentData.dealerCode = appointment.dealerCode;
    appointmentData.dealer = appointment.dealer;
    appointmentData.customer = appointment.customer;
    return appointmentData;
}